(function iefe(w, d) {
    /* set Toggle Button */
    function setToggle(col) {
        if (col.hasopen) {
            col.toggle.classList.add('Collapsibles__toggle-button--collapse');
        } else {
            col.toggle.classList.remove('Collapsibles__toggle-button--collapse');
        }
    }

    /* open a Collapsible */
    function openCollapsible(collapsible) {
        const button = collapsible.querySelector('.Collapsible__summary');
        collapsible.classList.add('Collapsible--open');
        if (button) {
            button.setAttribute('aria-expanded', 'true');
        }
    }

    /* close a Collapsible */
    function closeCollapsible(collapsible) {
        const button = collapsible.querySelector('.Collapsible__summary');
        collapsible.classList.remove('Collapsible--open');
        if (button) {
            button.setAttribute('aria-expanded', 'false');
        }
    }

    /* open or close all Collapsibles */
    function operateCollapsibles(col) {
        if (col.hasopen === true) {
            /* if one of the Collapsibles in the List is open, close all */
            col.container.querySelectorAll('.Collapsible--open').forEach((isopen) => {
                isopen.classList.remove('Collapsible--open');
                isopen.querySelector('[aria-expanded = true]').setAttribute('aria-expanded', 'false');
            });
            // eslint-disable-next-line no-param-reassign
            col.hasopen = false;
            setToggle(col);
        } else {
            /* if all of the Collapsibles in the List are closed, open all */
            col.container.querySelectorAll('.Collapsible').forEach((isopen) => {
                isopen.classList.add('Collapsible--open');
                isopen.querySelector('[aria-expanded = false]').setAttribute('aria-expanded', 'true');
            });
            // eslint-disable-next-line no-param-reassign
            col.hasopen = true;
            setToggle(col);
        }
    }

    /* Open a Collapsible with an id corresponding to the hash in the content  */
    function checkHash(collapsible) {
        const hash = decodeURIComponent(w.location.hash);
        if (collapsible.querySelector(hash)) {
            openCollapsible(collapsible);
        }
    }

    /* Create Collapsible from regular content */
    function createCollapsibles() {
        const collapsibles = d.querySelectorAll('.Collapsible');
        collapsibles.forEach((collapsible) => {
            const heading = collapsible.querySelector('.Collapsible__summary-heading');

            if (!heading) {
                return;
            }

            const button = d.createElement('button');
            let content = heading.innerHTML;
            const open = collapsible.classList.contains('Collapsible--open') ? 'true' : 'false';
            const collapsiblecontent = collapsible.querySelector('.Collapsible__content');
            const id = collapsiblecontent.getAttribute('id');
            collapsible.classList.remove('Collapsible--init');
            button.setAttribute('aria-expanded', open);
            button.classList.add('Collapsible__summary');

            if (id) {
                heading.setAttribute('id', `${id}-heading`);
                button.setAttribute('aria-controls', id);
            } else {
                const fallback = heading.querySelector('[id]');
                if (fallback) {
                    const fallbackid = fallback.getAttribute('id');
                    heading.querySelector('[id]').removeAttribute('id');
                    content = heading.innerHTML;
                    heading.setAttribute('id', `${fallbackid}-heading`);
                    button.setAttribute('aria-controls', fallbackid);
                    collapsiblecontent.setAttribute('id', fallbackid);
                }
            }
            button.innerHTML = content;
            heading.innerHTML = '';
            heading.appendChild(button);

            if (w.location.hash) {
                checkHash(collapsible);
            }

            heading.addEventListener('click', () => {
                const isopen = button.getAttribute('aria-expanded');
                if (isopen === 'true') {
                    closeCollapsible(collapsible);
                } else {
                    openCollapsible(collapsible);
                }
            });
        });
    }

    /* Create Collapsible List for Prüfschritte */
    function createCollapsibleList() {
        const collapsiblescontainers = d.querySelectorAll('.Collapsibles');
        collapsiblescontainers.forEach((collapsiblecontainer) => {
            const col = {};
            col.container = collapsiblecontainer;
            col.toggle = col.container.querySelector('.Collapsibles__toggle-button');
            col.summarys = col.container.querySelectorAll('.Collapsible__summary');
            col.collapsibles = col.container.querySelectorAll('.Collapsible');
            col.hasopen = !!col.container.querySelector('.Collapsible--open');

            /* on open or close Summary check if one is open and set Toggle button */
            col.summarys.forEach((summary) => {
                summary.addEventListener('click', () => {
                    setTimeout(() => {
                        col.hasopen = !!col.container.querySelector('.Collapsible--open');
                        setToggle(col);
                    }, 0);
                });
            });

            col.toggle.addEventListener('click', () => {
                operateCollapsibles(col);
            });
        });
    }

    createCollapsibles();

    createCollapsibleList();

    w.addEventListener('hashchange', () => {
        const { hash } = w.location;
        const collapsibles = d.querySelectorAll('.Collapsible');
        if (hash !== '') {
            collapsibles.forEach((col) => {
                checkHash(col);
            });
        }
    });
}(window, document));
